import { Component, OnInit } from '@angular/core';
import { Globals } from '../globals';

@Component({
  selector: 'app-authentication-failed',
  templateUrl: './authentication-failed.component.html',
  styleUrls: ['./authentication-failed.component.css']
})
export class AuthenticationFailedComponent implements OnInit {

  constructor(public globals: Globals) { }

  ngOnInit(): void {
  }

}
